import { useCallback } from 'react'

import { ERROR_CHECK_INVITATION } from '@/app/module/auth/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export type InvitationCheckParams = {
  invitationToken: string
}

export const useCheckInvitation = () => {
  const dispatch = useAppDispatch()
  const [inviteCheck, queryResult] = esApi.endpoints.inviteCheck.useLazyQuery()

  const checkInvitation = useCallback(
    async ({ invitationToken }: InvitationCheckParams) => {
      try {
        const response = await inviteCheck({ invtoken: invitationToken }).unwrap()
        return response
      } catch (error) {
        const errorMessage = getErrorMessage(error, ERROR_CHECK_INVITATION)
        dispatch(
          createNotification({
            'check-invitation-error': {
              type: 'error',
              message: errorMessage,
            },
          }),
        )
        return false
      }
    },
    [dispatch, inviteCheck],
  )

  return [checkInvitation, queryResult] as const
}
